// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #05070c;
  color: #f4f7fb;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

button,
input {
  font-family: inherit;
}

button {
  cursor: pointer;
}

.positive {
  color: #57ff68;
}

.negative {
  color: #ff604b;
}

/* ================= APP SHELL ================= */

.appShell {
  min-height: 100vh;
  display: block;
  background:
    radial-gradient(circle at top left, rgba(177, 136, 0, 0.18), transparent 32%),
    radial-gradient(circle at top right, rgba(177, 136, 0, 0.10), transparent 34%),
    radial-gradient(circle at bottom center, rgba(90, 64, 0, 0.12), transparent 38%),
    linear-gradient(180deg, #030303 0%, #070707 48%, #020202 100%);
}

.mainShell {
  min-width: 0;
}

.pageContent {
  padding: 16px;
  background:
    linear-gradient(180deg, rgba(177, 136, 0, 0.025), transparent 260px);
}

/* ================= TOP NAV ================= */

.topNav {
  min-height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  padding: 0 24px;
  border-bottom: 1px solid rgba(212, 175, 55, 0.22);
  background:
    linear-gradient(90deg, rgba(5, 5, 5, 0.96), rgba(8, 8, 12, 0.94)),
    radial-gradient(circle at top left, rgba(212, 175, 55, 0.12), transparent 32%);
  backdrop-filter: blur(14px);
  position: sticky;
  top: 0;
  z-index: 50;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.38);
}

.topBrand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 270px;
}

.brandLogo {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  border-radius: 9px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #050505;
  border: 1px solid rgba(212, 175, 55, 0.32);
  box-shadow:
    inset 0 0 10px rgba(212, 175, 55, 0.06),
    0 0 10px rgba(212, 175, 55, 0.08);
}

.brandLogoImage {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.brandTitle {
  color: #f4f1e8;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0.06em;
  line-height: 1;
}

.brandSubtitle {
  color: #d4af37;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  margin-top: 4px;
  line-height: 1;
}

.topTabs {
  display: flex;
  align-items: center;
  gap: 24px;
  min-width: 0;
}

.topTab {
  color: rgba(244, 241, 232, 0.78);
  text-decoration: none;
  height: 72px;
  display: flex;
  align-items: center;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  transition: color 0.18s ease, border-color 0.18s ease;
}

.topTab:hover {
  color: #f6d36b;
}

.topTab.active {
  color: #f6d36b;
  border-bottom-color: #d4af37;
}

.topTools {
  display: flex;
  align-items: center;
  gap: 10px;
}

.iconButton {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  color: #f6d36b;
  background: rgba(212, 175, 55, 0.08);
  border: 1px solid rgba(212, 175, 55, 0.26);
  box-shadow: inset 0 0 12px rgba(212, 175, 55, 0.06);
}

.iconButton:hover {
  background: rgba(212, 175, 55, 0.14);
  border-color: rgba(212, 175, 55, 0.42);
}

.iconButton.alarmEnabled {
  color: #57ff68;
  border-color: rgba(87, 255, 104, 0.45);
  background: rgba(87, 255, 104, 0.1);
}

.topNavMenuButton {
  display: none;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  color: #f6d36b;
  background: rgba(212, 175, 55, 0.08);
  border: 1px solid rgba(212, 175, 55, 0.28);
  font-size: 22px;
}

/* ================= COMMAND CENTER STRUCTURE ================= */

.commandCenterPage {
  display: grid;
  gap: 12px;
}

.commandStatusStrip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.statusTile {
  padding: 11px 14px;
  border-radius: 15px;
  background: linear-gradient(180deg, rgba(13, 18, 28, 0.94), rgba(8, 11, 18, 0.94));
  border: 1px solid rgba(255, 255, 255, 0.09);
  box-shadow: 0 16px 42px rgba(0, 0, 0, 0.22);
}

.statusTile span {
  display: block;
  color: #8f9bad;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 4px;
}

.statusTile strong {
  display: block;
  color: #f4f7fb;
  font-size: 18px;
  line-height: 1.08;
}

.statusTile small {
  display: block;
  color: #8f9bad;
  font-size: 11px;
  margin-top: 4px;
}

.dashboardGrid {
  display: grid;
  grid-template-columns: minmax(0, 2.25fr) minmax(340px, 0.9fr);
  grid-template-areas:
    "main monitor"
    "meic meic";
  gap: 12px;
  align-items: stretch;
}

.commandMainStack {
  grid-area: main;
  display: grid;
  grid-template-rows: auto auto;
  gap: 12px;
  min-width: 0;
}

.rightDashboardRail {
  grid-area: monitor;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  align-self: stretch;
}

.positionMonitorStack {
  display: grid;
  grid-template-rows: auto auto;
  gap: 12px;
  min-width: 0;
}

.meicPanel {
  grid-area: meic;
}

.panel {
  background: linear-gradient(180deg, rgba(13, 18, 28, 0.94), rgba(8, 11, 18, 0.94));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 13px;
  box-shadow: 0 20px 54px rgba(0, 0, 0, 0.25);
}

.panel h2 {
  margin: 0;
  font-size: 18px;
  line-height: 1.1;
}

.panel p {
  color: #a9b3c4;
  margin: 3px 0 0;
  font-size: 12px;
  line-height: 1.3;
}

.panelHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 11px;
}

.compactPanelHeader {
  margin-bottom: 9px;
}

.monitorCard {
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.tradeSignalsPanel,
.marketSnapshotPanel {
  min-width: 0;
}

.marketSnapshotPanel {
  overflow: hidden;
}



/* ================= TABLES ================= */

.dataTable {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.dataTable th,
.dataTable td {
  text-align: left;
  padding: 7px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  line-height: 1.16;
}

.dataTable th {
  color: #8f9bad;
  font-weight: 600;
  font-size: 11px;
}

.compactTable {
  font-size: 11px;
}

.compactTable th,
.compactTable td {
  padding: 6px 7px;
}

/* ================= MARKET STRUCTURE ================= */

.marketStructureGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 7px;
}

.structureMetric {
  padding: 9px 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.07);
}

.structureMetric span {
  display: block;
  color: #8f9bad;
  font-size: 9px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 4px;
}

.structureMetric strong {
  display: block;
  color: #f4f7fb;
  font-size: 14px;
  line-height: 1.1;
  margin-bottom: 2px;
}

.structureMetric small {
  display: block;
  color: #a9b3c4;
  font-size: 10px;
  line-height: 1.25;
}


/* ================= STRATEGY PAGES ================= */

.strategyPage {
  display: grid;
  gap: 18px;
}

.strategyPage h1 {
  margin: 0;
  font-size: 42px;
}

.strategyPage > p {
  margin: 0;
  color: #aab4c4;
  font-size: 18px;
}

/* ================= RESPONSIVE ================= */

@media (max-width: 1500px) {
  .dashboardGrid {
    grid-template-columns: minmax(0, 2fr) minmax(330px, 0.95fr);
  }

  .topTabs {
    gap: 18px;
  }

  .commandSignalGrid {
    gap: 10px;
  }
}

@media (max-width: 1250px) {
  .topNav {
    height: auto;
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
  }

  .topNavMenuButton {
    display: block;
  }

  .topTabs {
    display: none;
  }

  .topTabs.mobileNavOpen {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    padding-top: 10px;
  }

  .topTab {
    height: auto;
    min-height: 42px;
    justify-content: center;
    padding: 10px 12px;
    border-bottom: none;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.045);
    border: 1px solid rgba(255, 255, 255, 0.08);
    white-space: normal;
  }

  .topTab.active {
    color: #ff8a1f;
    border-color: rgba(255, 138, 31, 0.35);
    background: rgba(255, 138, 31, 0.08);
  }

  .topTools {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .pageContent {
    padding: 16px;
  }

  .dashboardGrid {
    grid-template-columns: 1fr;
    grid-template-areas:
      "main"
      "monitor"
      "meic";
  }

  .commandMainStack {
    grid-area: main;
    grid-template-rows: auto auto;
  }

  .rightDashboardRail {
    grid-area: monitor;
  }

  .positionMonitorStack {
    grid-template-rows: auto;
  }

  .commandStatusStrip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .commandSignalGrid {
    grid-template-columns: 1fr;
  }

  .commandSignalCard {
    min-height: auto;
  }

  .dataTable {
    min-width: 520px;
  }

  .monitorCard {
    overflow-x: auto;
  }

  .marketStructureGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 700px) {
  .topNav {
    grid-template-columns: 1fr auto;
  }

  .topBrand {
    min-width: 0;
  }

  .topBrand .brandTitle {
    font-size: 16px;
  }

  .topBrand .brandSubtitle {
    font-size: 10px;
  }

  .smallBrandIcon {
    width: 34px;
    height: 34px;
    font-size: 18px;
  }

  .topTools {
    grid-column: 1 / -1;
    justify-content: center;
  }

  .topTabs.mobileNavOpen {
    grid-template-columns: 1fr;
  }

  .commandStatusStrip {
    grid-template-columns: 1fr;
  }

  .panel {
    padding: 12px;
    border-radius: 14px;
  }

  .panel h2 {
    font-size: 17px;
  }

  .commandTradeStats {
    grid-template-columns: 1fr;
  }

  .snapshotGrid {
    grid-template-columns: 1fr;
  }

  .snapshotDetailGrid {
    grid-template-columns: 1fr 1fr;
  }

  .snapshotChart {
    height: 170px;
  }

  .marketStructureGrid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 520px) {
  .topTools {
    display: none;
  }

  .snapshotDetailGrid {
    grid-template-columns: 1fr;
  }

  .dataTable {
    min-width: 480px;
  }
}


/*Must keep this here to overide logo formatting isssues*/
.spxNavLogoBox {
  width: 30px !important;
  height: 30px !important;
  flex: 0 0 30px !important;
  min-width: 30px !important;
  max-width: 30px !important;
  min-height: 30px !important;
  max-height: 30px !important;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #050505;
  border: 1px solid rgba(212, 175, 55, 0.35);
}

.spxNavLogoImg {
  width: 22px !important;
  height: 22px !important;
  max-width: 22px !important;
  max-height: 22px !important;
  object-fit: contain;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,6EAA6E;AAC/E;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kDAAkD;;AAElD;EACE,iBAAiB;EACjB,cAAc;EACd;;;;kEAIgE;AAClE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb;wEACsE;AACxE;;AAEA,gDAAgD;;AAEhD;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iDAAiD;EACjD;;kFAEgF;EAChF,2BAA2B;EAC3B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C;;qCAEmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,eAAe;AACjB;;AAEA,iEAAiE;;AAEjE;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kFAAkF;EAClF,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D;;eAEa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kFAAkF;EAClF,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA,+CAA+C;;AAE/C;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,yDAAyD;;AAEzD;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;;AAGA,uDAAuD;;AAEvD;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,mDAAmD;;AAEnD;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,sCAAsC;IACtC,2CAA2C;IAC3C,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,oCAAoC;EACtC;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B;;;YAGQ;EACV;;EAEA;IACE,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;;AAGA,yDAAyD;AACzD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  background: #05070c;\n  color: #f4f7fb;\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\nbutton,\ninput {\n  font-family: inherit;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n.positive {\n  color: #57ff68;\n}\n\n.negative {\n  color: #ff604b;\n}\n\n/* ================= APP SHELL ================= */\n\n.appShell {\n  min-height: 100vh;\n  display: block;\n  background:\n    radial-gradient(circle at top left, rgba(177, 136, 0, 0.18), transparent 32%),\n    radial-gradient(circle at top right, rgba(177, 136, 0, 0.10), transparent 34%),\n    radial-gradient(circle at bottom center, rgba(90, 64, 0, 0.12), transparent 38%),\n    linear-gradient(180deg, #030303 0%, #070707 48%, #020202 100%);\n}\n\n.mainShell {\n  min-width: 0;\n}\n\n.pageContent {\n  padding: 16px;\n  background:\n    linear-gradient(180deg, rgba(177, 136, 0, 0.025), transparent 260px);\n}\n\n/* ================= TOP NAV ================= */\n\n.topNav {\n  min-height: 72px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 18px;\n  padding: 0 24px;\n  border-bottom: 1px solid rgba(212, 175, 55, 0.22);\n  background:\n    linear-gradient(90deg, rgba(5, 5, 5, 0.96), rgba(8, 8, 12, 0.94)),\n    radial-gradient(circle at top left, rgba(212, 175, 55, 0.12), transparent 32%);\n  backdrop-filter: blur(14px);\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.38);\n}\n\n.topBrand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 270px;\n}\n\n.brandLogo {\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  border-radius: 9px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #050505;\n  border: 1px solid rgba(212, 175, 55, 0.32);\n  box-shadow:\n    inset 0 0 10px rgba(212, 175, 55, 0.06),\n    0 0 10px rgba(212, 175, 55, 0.08);\n}\n\n.brandLogoImage {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n  display: block;\n}\n\n.brandTitle {\n  color: #f4f1e8;\n  font-size: 20px;\n  font-weight: 900;\n  letter-spacing: 0.06em;\n  line-height: 1;\n}\n\n.brandSubtitle {\n  color: #d4af37;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  margin-top: 4px;\n  line-height: 1;\n}\n\n.topTabs {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  min-width: 0;\n}\n\n.topTab {\n  color: rgba(244, 241, 232, 0.78);\n  text-decoration: none;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  border-bottom: 2px solid transparent;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 600;\n  transition: color 0.18s ease, border-color 0.18s ease;\n}\n\n.topTab:hover {\n  color: #f6d36b;\n}\n\n.topTab.active {\n  color: #f6d36b;\n  border-bottom-color: #d4af37;\n}\n\n.topTools {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.iconButton {\n  width: 38px;\n  height: 38px;\n  border-radius: 12px;\n  color: #f6d36b;\n  background: rgba(212, 175, 55, 0.08);\n  border: 1px solid rgba(212, 175, 55, 0.26);\n  box-shadow: inset 0 0 12px rgba(212, 175, 55, 0.06);\n}\n\n.iconButton:hover {\n  background: rgba(212, 175, 55, 0.14);\n  border-color: rgba(212, 175, 55, 0.42);\n}\n\n.iconButton.alarmEnabled {\n  color: #57ff68;\n  border-color: rgba(87, 255, 104, 0.45);\n  background: rgba(87, 255, 104, 0.1);\n}\n\n.topNavMenuButton {\n  display: none;\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  color: #f6d36b;\n  background: rgba(212, 175, 55, 0.08);\n  border: 1px solid rgba(212, 175, 55, 0.28);\n  font-size: 22px;\n}\n\n/* ================= COMMAND CENTER STRUCTURE ================= */\n\n.commandCenterPage {\n  display: grid;\n  gap: 12px;\n}\n\n.commandStatusStrip {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.statusTile {\n  padding: 11px 14px;\n  border-radius: 15px;\n  background: linear-gradient(180deg, rgba(13, 18, 28, 0.94), rgba(8, 11, 18, 0.94));\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  box-shadow: 0 16px 42px rgba(0, 0, 0, 0.22);\n}\n\n.statusTile span {\n  display: block;\n  color: #8f9bad;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 4px;\n}\n\n.statusTile strong {\n  display: block;\n  color: #f4f7fb;\n  font-size: 18px;\n  line-height: 1.08;\n}\n\n.statusTile small {\n  display: block;\n  color: #8f9bad;\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n.dashboardGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 2.25fr) minmax(340px, 0.9fr);\n  grid-template-areas:\n    \"main monitor\"\n    \"meic meic\";\n  gap: 12px;\n  align-items: stretch;\n}\n\n.commandMainStack {\n  grid-area: main;\n  display: grid;\n  grid-template-rows: auto auto;\n  gap: 12px;\n  min-width: 0;\n}\n\n.rightDashboardRail {\n  grid-area: monitor;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n  align-self: stretch;\n}\n\n.positionMonitorStack {\n  display: grid;\n  grid-template-rows: auto auto;\n  gap: 12px;\n  min-width: 0;\n}\n\n.meicPanel {\n  grid-area: meic;\n}\n\n.panel {\n  background: linear-gradient(180deg, rgba(13, 18, 28, 0.94), rgba(8, 11, 18, 0.94));\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 13px;\n  box-shadow: 0 20px 54px rgba(0, 0, 0, 0.25);\n}\n\n.panel h2 {\n  margin: 0;\n  font-size: 18px;\n  line-height: 1.1;\n}\n\n.panel p {\n  color: #a9b3c4;\n  margin: 3px 0 0;\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n.panelHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 11px;\n}\n\n.compactPanelHeader {\n  margin-bottom: 9px;\n}\n\n.monitorCard {\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.tradeSignalsPanel,\n.marketSnapshotPanel {\n  min-width: 0;\n}\n\n.marketSnapshotPanel {\n  overflow: hidden;\n}\n\n\n\n/* ================= TABLES ================= */\n\n.dataTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.dataTable th,\n.dataTable td {\n  text-align: left;\n  padding: 7px 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n  line-height: 1.16;\n}\n\n.dataTable th {\n  color: #8f9bad;\n  font-weight: 600;\n  font-size: 11px;\n}\n\n.compactTable {\n  font-size: 11px;\n}\n\n.compactTable th,\n.compactTable td {\n  padding: 6px 7px;\n}\n\n/* ================= MARKET STRUCTURE ================= */\n\n.marketStructureGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 7px;\n}\n\n.structureMetric {\n  padding: 9px 10px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.035);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.structureMetric span {\n  display: block;\n  color: #8f9bad;\n  font-size: 9px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 4px;\n}\n\n.structureMetric strong {\n  display: block;\n  color: #f4f7fb;\n  font-size: 14px;\n  line-height: 1.1;\n  margin-bottom: 2px;\n}\n\n.structureMetric small {\n  display: block;\n  color: #a9b3c4;\n  font-size: 10px;\n  line-height: 1.25;\n}\n\n\n/* ================= STRATEGY PAGES ================= */\n\n.strategyPage {\n  display: grid;\n  gap: 18px;\n}\n\n.strategyPage h1 {\n  margin: 0;\n  font-size: 42px;\n}\n\n.strategyPage > p {\n  margin: 0;\n  color: #aab4c4;\n  font-size: 18px;\n}\n\n/* ================= RESPONSIVE ================= */\n\n@media (max-width: 1500px) {\n  .dashboardGrid {\n    grid-template-columns: minmax(0, 2fr) minmax(330px, 0.95fr);\n  }\n\n  .topTabs {\n    gap: 18px;\n  }\n\n  .commandSignalGrid {\n    gap: 10px;\n  }\n}\n\n@media (max-width: 1250px) {\n  .topNav {\n    height: auto;\n    display: grid;\n    grid-template-columns: 1fr auto auto;\n    align-items: center;\n    gap: 12px;\n    padding: 14px 16px;\n  }\n\n  .topNavMenuButton {\n    display: block;\n  }\n\n  .topTabs {\n    display: none;\n  }\n\n  .topTabs.mobileNavOpen {\n    grid-column: 1 / -1;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n    padding-top: 10px;\n  }\n\n  .topTab {\n    height: auto;\n    min-height: 42px;\n    justify-content: center;\n    padding: 10px 12px;\n    border-bottom: none;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.045);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    white-space: normal;\n  }\n\n  .topTab.active {\n    color: #ff8a1f;\n    border-color: rgba(255, 138, 31, 0.35);\n    background: rgba(255, 138, 31, 0.08);\n  }\n\n  .topTools {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n  }\n\n  .pageContent {\n    padding: 16px;\n  }\n\n  .dashboardGrid {\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      \"main\"\n      \"monitor\"\n      \"meic\";\n  }\n\n  .commandMainStack {\n    grid-area: main;\n    grid-template-rows: auto auto;\n  }\n\n  .rightDashboardRail {\n    grid-area: monitor;\n  }\n\n  .positionMonitorStack {\n    grid-template-rows: auto;\n  }\n\n  .commandStatusStrip {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .commandSignalGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .commandSignalCard {\n    min-height: auto;\n  }\n\n  .dataTable {\n    min-width: 520px;\n  }\n\n  .monitorCard {\n    overflow-x: auto;\n  }\n\n  .marketStructureGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 700px) {\n  .topNav {\n    grid-template-columns: 1fr auto;\n  }\n\n  .topBrand {\n    min-width: 0;\n  }\n\n  .topBrand .brandTitle {\n    font-size: 16px;\n  }\n\n  .topBrand .brandSubtitle {\n    font-size: 10px;\n  }\n\n  .smallBrandIcon {\n    width: 34px;\n    height: 34px;\n    font-size: 18px;\n  }\n\n  .topTools {\n    grid-column: 1 / -1;\n    justify-content: center;\n  }\n\n  .topTabs.mobileNavOpen {\n    grid-template-columns: 1fr;\n  }\n\n  .commandStatusStrip {\n    grid-template-columns: 1fr;\n  }\n\n  .panel {\n    padding: 12px;\n    border-radius: 14px;\n  }\n\n  .panel h2 {\n    font-size: 17px;\n  }\n\n  .commandTradeStats {\n    grid-template-columns: 1fr;\n  }\n\n  .snapshotGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .snapshotDetailGrid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .snapshotChart {\n    height: 170px;\n  }\n\n  .marketStructureGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 520px) {\n  .topTools {\n    display: none;\n  }\n\n  .snapshotDetailGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .dataTable {\n    min-width: 480px;\n  }\n}\n\n\n/*Must keep this here to overide logo formatting isssues*/\n.spxNavLogoBox {\n  width: 30px !important;\n  height: 30px !important;\n  flex: 0 0 30px !important;\n  min-width: 30px !important;\n  max-width: 30px !important;\n  min-height: 30px !important;\n  max-height: 30px !important;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #050505;\n  border: 1px solid rgba(212, 175, 55, 0.35);\n}\n\n.spxNavLogoImg {\n  width: 22px !important;\n  height: 22px !important;\n  max-width: 22px !important;\n  max-height: 22px !important;\n  object-fit: contain;\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
